//import {BrowserRouter as Router, Route} from "react-router-dom";
import { Suspense, lazy, useState, useEffect } from "react";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ErrorBoundary from "./components/ErrorBoundary";
import { ReactComponent as TidaLogo } from "./tida.svg";
import NotFound from "./components/NotFound";
import "bootstrap/dist/css/bootstrap.min.css"
import Home from "./components/home.component";
const AnimatedCursor = lazy(() => import("react-animated-cursor"));

//Professional
const Professional = lazy(() => import("./components/all_professional/professional.component"));
const Allergy = lazy(() => import("./components/allergies.component"));
const MentorshipPage = lazy(() => import("./components/all_professional/mentorship.component"));

//Personal
const Blog = lazy(() => import("./components/all_blog/blog.component"));
const ViewRecipie = lazy(() => import("./components/all_recipie/viewRecipie.component"));
const Recipies = lazy(() => import("./components/all_recipie/recipies.component"));
// const Recipies3 = lazy(() => import("./components/all_recipie/recipiebud.component"));
const Provoke = lazy(() => import("./components/AI/provoke.component"));
const Raag = lazy(() => import("./components/raag.component"));
// const Raag2 = lazy(() => import("./components/raag2.component"));
const Fly = lazy(() => import("./components/flight.component"));
const Image = lazy(() => import("./components/image.component"));
const SignalRoom = lazy(() => import("./components/signal-room.component"));
const Experiences = lazy(() => import("./components/experiences.component"));

//Ambassadors
const AmbassadorsPortal  = lazy(() => import("./components/ambassadors/index"));
const AmbassadorsFeedback = lazy(() => import("./components/ambassadors/feedback"));

//Jainism
const JainismPage = lazy(() => import("./components/jainism/jainism.component"));

//PP
const CRM = lazy(() => import("./components/pp/crm.component"));
const Notes = lazy(() => import("./components/pp/notes-list.component"));
const PlaygroundHome = lazy(() => import("./components/pp/playground-home.component"));

const isMobile = () => window.matchMedia('(pointer: coarse)').matches;

function App() {
  const [showCursor, setShowCursor] = useState(false);
  useEffect(() => { setShowCursor(!isMobile()); }, []);

  return (

    <HelmetProvider>
    <Router>
          {showCursor && (
            <Suspense fallback={null}>
              <AnimatedCursor
                innerSize={8}
                outerSize={8}
                color='255,214,0'
                outerAlpha={0.2}
                innerScale={0.7}
                outerScale={5}
                outerStyle={{ zIndex: 10000 }}
                clickables={['a','input[type="text"]','input[type="email"]','input[type="number"]','input[type="submit"]','input[type="image"]','label[for]','select','textarea','button','.link']}
              />
            </Suspense>
          )}

      <ErrorBoundary>
      <Suspense fallback={
        <div style={{ display:'flex', justifyContent:'center', alignItems:'center', minHeight:'100vh', backgroundColor:'#000' }}>
          <TidaLogo style={{ width: 64, height: 64, fill: '#FFD200', animation: 'tidaPulse 1.2s ease-in-out infinite' }} />
        </div>
      }>
        <Routes>  
        <Route path="/" exact element={<Home/>}/>
        <Route path="/blog" exact element={<Blog/>}/>
        <Route path="/allergies" exact element={<Allergy/>}/>
        <Route path="/mentor" exact element={<MentorshipPage/>}/>
        <Route path="/recipies" exact element={<Recipies/>}/>
        {/* <Route path="/recipies3" exact element={<Recipies3/>}/> */}
        <Route path="/recipies/view/:id/*" exact element={<ViewRecipie/>}/>
        <Route path="/professional" exact element={<Professional/>}/>
        <Route path="/provoke" exact element={<Provoke/>}/>
        <Route path="/signal" exact element={<SignalRoom/>}/>
        <Route path="/experiences" exact element={<Experiences/>}/>
        <Route path="/raagplayer" exact element={<Raag/>}/>
        <Route path="/fly" exact element={<Fly/>}/>
        <Route path="/tf" exact element={<Image/>}/>
        <Route path="/ambassadors" element={<AmbassadorsPortal/>}/>
        <Route path="/ambassadors/feedback" element={<AmbassadorsFeedback/>}/>
        <Route path="/jainism" element={<JainismPage/>}/>
        <Route path="/project-playground" exact element={<PlaygroundHome/>}/>
        <Route path="/project-playground/notes" exact element={<Notes/>}/>
        <Route path="/project-playground/crm" exact element={<CRM/>}/>
        <Route path="/project-playground/birthdays" exact element={<CRM/>}/>
        <Route path="*" element={<NotFound/>}/>
      </Routes>
      </Suspense>
      </ErrorBoundary>

    </Router>
    </HelmetProvider>

  );
}

export default App;
